import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { LandLineListInterface } from '../models/land-line-list.interface';
import { ShiftAppointmentInterface } from '../models/shift-appointment.interface';
import { ShiftAppointmentResponseInterface } from '../models/shift-appointment-response.interface';
import { LandlineConsumptionInterface } from '../models/landline-consumption.interface';

@Injectable()
export class LandLinesService {

  constructor(private apiService: ApiService) {}

  /**
   * Get landLine list
   */
  getLandLineList(): Observable<Array<LandLineListInterface>> {
    return this.apiService.get('customer/landline/list');
  }

  /**
   * Get appointments list
   * @param buildingId
   * @param interventionType
   */
  getList(buildingId: string|null, interventionType: string): Observable<any> {
    return this.apiService.post('vitrine/box/appointments/list', { id_block: buildingId, intervention_type: interventionType });
  }

  /**
   * @param data
   */
  shiftAppointment(data: ShiftAppointmentInterface): Observable<ShiftAppointmentResponseInterface> {
    return this.apiService.post('shift/appointment', data);
  }

  /**
   * Get landLine consumption
   * @param landLine
   */
  getLandLineConsumption(landLine: string): Observable<LandlineConsumptionInterface> {
    return this.apiService.get('front/landline/' + landLine + '/consumption');
  }
}
